import {
  HttpGetRequest,
  HttpPostRequest,
  HttpPutRequest,
} from "./HttpRequest.js";

export async function create(carePlan) {
  let url = "/care_plan";
  return await HttpPostRequest(url, carePlan).then((response) => {
    return response.json();
  });
}

export async function update(id, carePlan) {
  let url = "/care_plan/" + id;
  return await HttpPutRequest(url, carePlan).then((response) => {
    return response.json();
  });
}

export async function getOne(carePlanId) {
  let url = "/care_plan/" + carePlanId;
  return await HttpGetRequest(url).then((response) => {
    return response.json();
  });
}

export async function all(payload) {
  let url = "/care_plans";
  return await HttpPostRequest(url, payload).then((response) => {
    return response.json();
  });
}
